<!--登录组件-->
<template>
  <div class="container">
    <div class="logo mt-n16">
      <img src="@/assets/bayer-logo.png" />
    </div>
    <div class="headline mt-4">SMS Monitoring Portal</div>
    <div class="mt-16">
      <v-btn class="button" @click="login()">Login</v-btn>
    </div>
    <core-confirm ref="confirm" @confirm="confirm" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CoreConfirm from '@/components/core/confirm.vue'

export default {
  components: {
    CoreConfirm,
  },
  data: () => ({}),
  computed: {
    ...mapState({
      base: (state) => state.base,
    }),
  },
  async mounted() {
    await this.$msal.ready()
    if (this.$msal.isAuthenticated()) {
      this.base.user = this.$msal.getUser()
      this.$router.push('query')
      return
    }
    const error = this.$msal.getLastLoginError()
    if (error) {
      const detail = this.$msal.getLastLoginErrorText
        ? this.$msal.getLastLoginErrorText()
        : String(error)
      const lower = (detail || '').toLowerCase()
      const looksLikePermission =
        lower.indexOf('access_denied') >= 0 ||
        lower.indexOf('consent') >= 0 ||
        lower.indexOf('aadsts50105') >= 0 ||
        lower.indexOf('aadsts65001') >= 0 ||
        lower.indexOf('not permission') >= 0
      const friendlymessage = looksLikePermission
        ? 'You haven not permission to access this site, please contact administrator to give your permission. '
        : `Login failed: ${detail}`
      this.$refs.confirm.show(friendlymessage, {
        titleText: 'Login Failed',
        type: 'alert',
        data: 'submitted',
      })
      this.$msal.clearLoginError()
    }
  },
  methods: {
    confirm() {},
    login() {
      this.$msal.signIn()
    },
  },
}
</script>
<style>
.button{
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: white !important;
}
.container {
  background: #1cade4;
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0%, #1cade4),
    color-stop(100%, #47c079)
  );
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 120px;
  height: 120px;
}

.logo img {
  width: 120px;
  height: 120px;
}
</style>
